<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('hwadzan-garden.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item>{{ $t('hwadzan-garden.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'intro' }">{{ $t('hwadzan-garden.detail.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b-nav pills fill>
          <b-nav-item :to="{ name: 'hwadzan-garden-intro' }" active>{{ $t('hwadzan-garden.detail.title') }}</b-nav-item>
          <b-nav-item :to="{ name: 'latest-events' }">{{ $t('event.list.latest.title') }}</b-nav-item>
          <b-nav-item :to="{ name: 'event-review' }">{{ $t('event.list.review.title') }}</b-nav-item>
        </b-nav>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <template v-if="$i18n.locale === 'en'">
          The Foundation has established the "Hwadzan Teaching Garden" in Shenkeng District, New Taipei City. In addition to providing teaching and group practice for the Foundation, it is also open free of charge to organizations with proper views to hold various Buddhist study and activities beneficial to body and mind, such as Buddha recitation retreats, Zen retreats, or children's Buddhist camps.<br>
          With the completion and opening of the park, the Foundation's Dharma propagation goals are currently planned in four main directions:<br>
          <ul>
            <li>1. Continue to promote the distribution of Buddhist scriptures.</li>
            <li>2. Expand the provision of Buddhist information services on the Internet, especially in audio and video.</li>
            <li>3. In terms of understanding, overall planning of Buddhist courses.</li>
            <li>4. In terms of practice, enhance public participation in Buddha recitation group practice and strengthen practical courses such as meditation.</li>
          </ul>
        </template>
        <template v-else>
          目前基金會於新北市深坑區，設立「華藏教學園區」，除可提供基金會教學及共修之外，亦可對外免費開放給具正知見之人民團體，來舉辦各種佛教修學及有益身心、增長智慧之活動，例如：佛七、禪七或兒童佛學冬夏令營等。<br>
          配合園區的落成啟用，基金會的弘法目標，目前規畫成四個大方向：<br>
          <ul>
            <li>1.印贈經書工作的持續推動。</li>
            <li>2.擴大網際網路佛法資訊服務的提供，尤其在影音方面。</li>
            <li>3.解門方面，佛學課程的總體性規畫。</li>
            <li>4.行門方面，增進大眾參與念佛共修的意願，以及加強禪定靜坐等實修課程。</li>
          </ul>
        </template>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●{{ $t('hwadzan-garden.detail.label.address') }}</h3>
        {{ $t('hwadzan-garden.detail.value.address') }}
        <h3>●{{ $t('hwadzan-garden.detail.label.tel-and-fax') }}</h3>
        {{ $t('hwadzan-garden.detail.value.tel-and-fax') }}
        <h3>●{{ $t('hwadzan-garden.detail.label.rule') }}</h3>
        (1) <a href="https://www2.budaedu.org/official-website-data/hwadzan-garden/hwazan_rule.htm">{{ $t('hwadzan-garden.detail.link.rule-web-ver') }}</a>({{ $t('hwadzan-garden.detail.message.online-ver') }})
        <br>(2) <a href="https://www2.budaedu.org/official-website-data/hwadzan-garden/hwazan_rule.doc">{{ $t('hwadzan-garden.detail.link.rule-download-ver') }}</a>({{ $t('hwadzan-garden.detail.message.doc-format') }})
        <h3>●{{ $t('hwadzan-garden.detail.label.borrowing-application-form') }}</h3>
        (1) <a href="https://www2.budaedu.org/official-website-data/hwadzan-garden/application.doc">{{ $t('hwadzan-garden.detail.link.borrowing-application-form') }}</a>({{ $t('hwadzan-garden.detail.message.doc-format') }})
        <h3>●{{ $t('hwadzan-garden.detail.label.map') }}</h3>
        (1) <a href="https://www2.budaedu.org/official-website-data/hwadzan-garden/traffic.htm">{{ $t('hwadzan-garden.detail.link.illustrated-driving-map') }}</a><br>
        (2) <a href="https://www.google.com/maps/place/222%E6%96%B0%E5%8C%97%E5%B8%82%E6%B7%B1%E5%9D%91%E5%8D%80%E5%A4%A7%E5%B4%99%E5%B0%BE/@24.9747816,121.6063642,15z/data=!3m1!4b1!4m6!3m5!1s0x3442aaa6291da4f9:0xcc73019a7e4543aa!8m2!3d24.974763!4d121.616664!16s%2Fg%2F1tf_f397?entry=ttu">google Map</a>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●{{ $t('hwadzan-garden.detail.label.map') }}</h3>
        <img src="https://www2.budaedu.org/official-website-data/hwadzan-garden/traffic001.jpg" :alt="$t('hwadzan-garden.detail.link.illustrated-driving-map')" style="max-width:100%;height:auto;">
      </div>
    </div>
    <b-overlay :show="is_loading" rounded="sm" opacity="0.6">
      <div class="row mt-3">
        <div class="col-12">
          <h3>●{{ $t('hwadzan-garden.detail.photo-list.title') }}</h3>
            <div v-for="(group, group_index) in garden_photo_groups" :key="`group-${group_index}`" class="mb-4">
                <h4 class="mt-3">{{ $t(group.title) }}</h4>
                <b-img 
                  v-for="(photo, photo_index) in group.photos" 
                  :key="`photo-${group_index}-${photo_index}`" 
                  :src="photo.src" 
                  fluid class="mb-3"
                ></b-img>
                <!-- <b-img 
                  v-for="(photo, photo_index) in group.photos" 
                  :key="`photo-${group_index}-${photo_index}`" 
                  :src="photo.src" 
                  :alt="photo.alt | $t" 
                  fluid class="mb-3"
                ></b-img> -->
            </div>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="arrow-clockwise" font-scale="5" animation="spin-pulse"></b-icon>
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'
import { OverlayPlugin } from 'bootstrap-vue'
import { TabsPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ButtonPlugin)
Vue.use(IconsPlugin)
Vue.use(ImagePlugin)
Vue.use(OverlayPlugin)
Vue.use(TabsPlugin)

export default {
  i18n,
  name: "hwadzan-garden-intro",
  data() {
    return {
      is_loading: false,
      garden_photo_groups: [
        {
          title: 'hwadzan-garden.detail.photo-list.buddha-hall.title',
          photos: [
            {
              src: 'https://www2.budaedu.org/official-website-data/hwadzan-garden/photo/buddha_hall_01.jpg',
              alt: 'hwadzan-garden.detail.photo-alt.buddha-hall-1'
            },
            {
              src: 'https://www2.budaedu.org/official-website-data/hwadzan-garden/photo/buddha_hall_02.jpg',
              alt: 'hwadzan-garden.detail.photo-alt.buddha-hall-2'
            },
            {
              src: 'https://www2.budaedu.org/official-website-data/hwadzan-garden/photo/buddha_hall_03.jpg',
              alt: 'hwadzan-garden.detail.photo-alt.buddha-hall-3'
            },
          ]
        },
        {
          title: 'hwadzan-garden.detail.photo-list.plaza.title',
          photos: [
            {
              src: 'https://www2.budaedu.org/official-website-data/hwadzan-garden/photo/plaza_01.jpg',
              alt: 'hwadzan-garden.detail.photo-alt.plaza-1'
            },
            {
              src: 'https://www2.budaedu.org/official-website-data/hwadzan-garden/photo/plaza_02.jpg',
              alt: 'hwadzan-garden.detail.photo-alt.plaza-2'
            },
          ]
        },
        {
          title: 'hwadzan-garden.detail.photo-list.corridor.title',
          photos: [
            {
              src: 'https://www2.budaedu.org/official-website-data/hwadzan-garden/photo/corridor_01.jpg',
              alt: 'hwadzan-garden.detail.photo-alt.corridor-1'
            },
            {
              src: 'https://www2.budaedu.org/official-website-data/hwadzan-garden/photo/corridor_02.jpg',
              alt: 'hwadzan-garden.detail.photo-alt.corridor-2'
            },
          ]
        },
        {
          title: 'hwadzan-garden.detail.photo-list.outdoor.title',
          photos: [
            {
              src: 'https://www2.budaedu.org/official-website-data/hwadzan-garden/photo/outdoor_01.jpg',
              alt: 'hwadzan-garden.detail.photo-alt.outdoor-1'
            },
            {
              src: 'https://www2.budaedu.org/official-website-data/hwadzan-garden/photo/outdoor_02.jpg',
              alt: 'hwadzan-garden.detail.photo-alt.outdoor-2'
            },
          ]
        },
        {
          title: 'hwadzan-garden.detail.photo-list.dining-hall.title',
          photos: [
            {
              src: 'https://www2.budaedu.org/official-website-data/hwadzan-garden/photo/dining_hall_01.jpg',
              alt: 'hwadzan-garden.detail.photo-alt.dining-hall-1'
            },
          ]
        },
        {
          title: 'hwadzan-garden.detail.photo-list.admin-center.title',
          photos: [
            {
              src: 'https://www2.budaedu.org/official-website-data/hwadzan-garden/photo/admin_center_01.jpg',
              alt: 'hwadzan-garden.detail.photo-alt.admin-center-1'
            },
          ]
        },
        {
          title: 'hwadzan-garden.detail.photo-list.dormitory.title',
          photos: [
            {
              src: 'https://www2.budaedu.org/official-website-data/hwadzan-garden/photo/dormitory_01.jpg',
              alt: 'hwadzan-garden.detail.photo-alt.dormitory-1'
            },
          ]
        }
      ]
    };
  },
  created() {
    //alert(`Vue version : ${Vue.version}`)
    this.is_loading = true
    this.$nextTick(() => {
      this.is_loading = false
    })
  },
  components: {
    //
  },
  metaInfo() {
    return {
      title: this.$t('hwadzan-garden.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
};
</script>